import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ResponsiveWidthValue } from 'styled-system';
import { theme } from '~ui-kit/theme';
import { Box, BoxProps } from './box.component';

interface Props extends BoxProps {
  children: ReactNode;
  id?: string;
  maxWidth?: ResponsiveWidthValue;
}

// Light grey container highlighting form elements
export function FormContainer({ children, ...rest }: Props) {
  return (
    <StyledBox background={theme.colors.subquestionContainer} {...rest} flexDirection="column">
      {children}
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  border-radius: 20px;
`;
